/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  IllustListMasters,
  ErrorInfo,
  GetIllustListUnusedlist200,
  IllustList,
  IllustListSearchConditions,
  PostIllustListRemoveUnusedIllusts200,
  PostIllustListRemoveUnusedIllustsBody,
  BinaryFile,
  PostIllustListDownloadIllustsBody,
  PostIllustListDownloadIllustBody,
  PostIllustListDownloadMultipleLanguageIllustsBody
} from '.././model'


/**
 * イラスト一覧に必要なマスタを一括取得して返す。

 * @summary イラスト一覧マスタ一括取得
 */
export const getIllustListMasters = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<IllustListMasters>> => {
    return axios.get(
      `/illustList/masters`,options
    );
  }


export const getGetIllustListMastersQueryKey = () => [`/illustList/masters`];

    
export type GetIllustListMastersQueryResult = NonNullable<Awaited<ReturnType<typeof getIllustListMasters>>>
export type GetIllustListMastersQueryError = AxiosError<ErrorInfo>

export const useGetIllustListMasters = <TData = Awaited<ReturnType<typeof getIllustListMasters>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIllustListMasters>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIllustListMastersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIllustListMasters>>> = ({ signal }) => getIllustListMasters({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getIllustListMasters>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * イラスト一覧に必要なマスタを一括取得して返す。

 * @summary イラスト一覧マスタ一括取得
 */
export const getIllustListUnusedlist = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetIllustListUnusedlist200>> => {
    return axios.get(
      `/illustList/unusedlist`,options
    );
  }


export const getGetIllustListUnusedlistQueryKey = () => [`/illustList/unusedlist`];

    
export type GetIllustListUnusedlistQueryResult = NonNullable<Awaited<ReturnType<typeof getIllustListUnusedlist>>>
export type GetIllustListUnusedlistQueryError = AxiosError<ErrorInfo>

export const useGetIllustListUnusedlist = <TData = Awaited<ReturnType<typeof getIllustListUnusedlist>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIllustListUnusedlist>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIllustListUnusedlistQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIllustListUnusedlist>>> = ({ signal }) => getIllustListUnusedlist({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getIllustListUnusedlist>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * イラスト一覧を取得する
 * @summary イラスト一覧取得
 */
export const postIllustListSearch = (
    illustListSearchConditions: IllustListSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<IllustList>> => {
    return axios.post(
      `/illustList/search`,
      illustListSearchConditions,options
    );
  }



    export type PostIllustListSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postIllustListSearch>>>
    export type PostIllustListSearchMutationBody = IllustListSearchConditions
    export type PostIllustListSearchMutationError = AxiosError<ErrorInfo>

    export const usePostIllustListSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIllustListSearch>>, TError,{data: IllustListSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIllustListSearch>>, {data: IllustListSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postIllustListSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postIllustListSearch>>, TError, {data: IllustListSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * システム内でどこからもされていない不要イラストを一括削除する
 * @summary 不要イラスト一括削除
 */
export const postIllustListRemoveUnusedIllusts = (
    postIllustListRemoveUnusedIllustsBody: PostIllustListRemoveUnusedIllustsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostIllustListRemoveUnusedIllusts200>> => {
    return axios.post(
      `/illustList/removeUnusedIllusts`,
      postIllustListRemoveUnusedIllustsBody,options
    );
  }



    export type PostIllustListRemoveUnusedIllustsMutationResult = NonNullable<Awaited<ReturnType<typeof postIllustListRemoveUnusedIllusts>>>
    export type PostIllustListRemoveUnusedIllustsMutationBody = PostIllustListRemoveUnusedIllustsBody
    export type PostIllustListRemoveUnusedIllustsMutationError = AxiosError<ErrorInfo>

    export const usePostIllustListRemoveUnusedIllusts = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIllustListRemoveUnusedIllusts>>, TError,{data: PostIllustListRemoveUnusedIllustsBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIllustListRemoveUnusedIllusts>>, {data: PostIllustListRemoveUnusedIllustsBody}> = (props) => {
          const {data} = props ?? {};

          return  postIllustListRemoveUnusedIllusts(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postIllustListRemoveUnusedIllusts>>, TError, {data: PostIllustListRemoveUnusedIllustsBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 指定したイラスト(複数指定可)を一括ダウンロードする
 * @summary イラストの一括ダウンロード
 */
export const postIllustListDownloadIllusts = (
    postIllustListDownloadIllustsBody: PostIllustListDownloadIllustsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/illustList/downloadIllusts`,
      postIllustListDownloadIllustsBody,options
    );
  }



    export type PostIllustListDownloadIllustsMutationResult = NonNullable<Awaited<ReturnType<typeof postIllustListDownloadIllusts>>>
    export type PostIllustListDownloadIllustsMutationBody = PostIllustListDownloadIllustsBody
    export type PostIllustListDownloadIllustsMutationError = AxiosError<ErrorInfo>

    export const usePostIllustListDownloadIllusts = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIllustListDownloadIllusts>>, TError,{data: PostIllustListDownloadIllustsBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIllustListDownloadIllusts>>, {data: PostIllustListDownloadIllustsBody}> = (props) => {
          const {data} = props ?? {};

          return  postIllustListDownloadIllusts(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postIllustListDownloadIllusts>>, TError, {data: PostIllustListDownloadIllustsBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 指定したイラスト(1件)をダウンロードする
 * @summary イラストダウンロード
 */
export const postIllustListDownloadIllust = (
    postIllustListDownloadIllustBody: PostIllustListDownloadIllustBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/illustList/downloadIllust`,
      postIllustListDownloadIllustBody,options
    );
  }



    export type PostIllustListDownloadIllustMutationResult = NonNullable<Awaited<ReturnType<typeof postIllustListDownloadIllust>>>
    export type PostIllustListDownloadIllustMutationBody = PostIllustListDownloadIllustBody
    export type PostIllustListDownloadIllustMutationError = AxiosError<ErrorInfo>

    export const usePostIllustListDownloadIllust = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIllustListDownloadIllust>>, TError,{data: PostIllustListDownloadIllustBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIllustListDownloadIllust>>, {data: PostIllustListDownloadIllustBody}> = (props) => {
          const {data} = props ?? {};

          return  postIllustListDownloadIllust(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postIllustListDownloadIllust>>, TError, {data: PostIllustListDownloadIllustBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 指定したイラストの主言語版と他言語版を一括ダウンロードする
 * @summary イラストの他言語一括ダウンロード
 */
export const postIllustListDownloadMultipleLanguageIllusts = (
    postIllustListDownloadMultipleLanguageIllustsBody: PostIllustListDownloadMultipleLanguageIllustsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/illustList/downloadMultipleLanguageIllusts`,
      postIllustListDownloadMultipleLanguageIllustsBody,options
    );
  }



    export type PostIllustListDownloadMultipleLanguageIllustsMutationResult = NonNullable<Awaited<ReturnType<typeof postIllustListDownloadMultipleLanguageIllusts>>>
    export type PostIllustListDownloadMultipleLanguageIllustsMutationBody = PostIllustListDownloadMultipleLanguageIllustsBody
    export type PostIllustListDownloadMultipleLanguageIllustsMutationError = AxiosError<ErrorInfo>

    export const usePostIllustListDownloadMultipleLanguageIllusts = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIllustListDownloadMultipleLanguageIllusts>>, TError,{data: PostIllustListDownloadMultipleLanguageIllustsBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIllustListDownloadMultipleLanguageIllusts>>, {data: PostIllustListDownloadMultipleLanguageIllustsBody}> = (props) => {
          const {data} = props ?? {};

          return  postIllustListDownloadMultipleLanguageIllusts(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postIllustListDownloadMultipleLanguageIllusts>>, TError, {data: PostIllustListDownloadMultipleLanguageIllustsBody}, TContext>(mutationFn, mutationOptions)
    }
    